module.exports = __webpack_public_path__ + "static/media/view test.2cdfeb32.svg";